import React from "react";
import { ConcessionairesTemplate } from "../../Templates/ConcessionairesTemplate";

export const Concessionaires = () => {
  return <ConcessionairesTemplate />;
};
